import ConnectLogin from './connect-login.vue';

export default ConnectLogin;
